<template>
  <div id="app">
    <TopMenu v-if="$route.name == 'home' || ($route.name == 'oferta' && ! loggedIn)" />
    <PopupMessage />

    <router-view/>

    <BottomMenu v-if="loggedIn" />
    <LeftMenu v-if="loggedIn" />
  </div>
</template>

<script>
  import TopMenu from '@/components/visual/TopMenu'
  import BottomMenu from '@/components/visual/BottomMenu'
  import LeftMenu from '@/components/visual/LeftMenu'
  import PopupMessage from '@/components/visual/PopupMessage'
import { mapGetters } from 'vuex'
  export default {
    components: { TopMenu, BottomMenu, LeftMenu, PopupMessage },
    mounted() {
      this.$store.dispatch('support/watch')
    },
    computed: {
      ...mapGetters('auth', ['loggedIn']),
    }
  }
</script>
